import React, { ReactElement, useState } from 'react';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import { CloseIcon, MenuIcon } from '../../design-system/icons/icons';

import Button from '../../design-system/Button';
import Logo from './Logo';
import NavLink from '../../design-system/NavLink';

const MobileNavBar: React.FC = (): ReactElement => {
  const [isOpen, setOpen] = useState(false);
  return (
    <div className="flex justify-between items-center p-4 box-border sm:hidden sticky top-0 bg-light">
      <Logo />
      <Button variant="clean" color="primary" className="!p-0">
        <MenuIcon
          size="3rem"
          onClick={() => {
            setOpen(true);
          }}
        />
      </Button>
      <Dialog
        isOpen={isOpen}
        aria-label="heading"
        className="flex flex-col items-end text-dark fixed top-0 right-0 !m-0 !p-4"
      >
        <div className="text-dark w-full flex justify-end h-24 items-center">
          <Button
            variant="clean"
            className="!p-0"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon size="3rem" />
          </Button>
        </div>
        <NavLink
          to="prezentare"
          className="text-lg font-bold py-2 px-4"
          onClick={() => {
            setOpen(false);
            window.scroll(0, 0);
          }}
        >
          Prezentare
        </NavLink>
        <NavLink
          to="cabinet"
          className="text-lg font-bold py-2 px-4"
          onClick={() => {
            setOpen(false);
            window.scroll(0, 0);
          }}
        >
          Cabinet
        </NavLink>
        <NavLink
          to="servicii"
          className="text-lg font-bold py-2 px-4"
          onClick={() => {
            setOpen(false);
            window.scroll(0, 0);
          }}
        >
          Servicii
        </NavLink>
        <NavLink
          to="blog"
          className="text-lg font-bold py-2 px-4"
          onClick={() => {
            setOpen(false);
            window.scroll(0, 0);
          }}
        >
          Blog
        </NavLink>
        <NavLink
          to="contact"
          className="text-lg font-bold py-2 px-4"
          onClick={() => {
            setOpen(false);
            window.scroll(0, 0);
          }}
        >
          Contact
        </NavLink>
      </Dialog>
    </div>
  );
};

export default MobileNavBar;
